export default __webpack_public_path__ + "static/contra-cc681f5b3f2be9c63122921ff4ef5661.png";